export enum FpsSync {
    NULL,
    LEFT_DOWN = 1,
    RIGHT_DOWN = 2,
    LEFT_UP = 3,
    RIGHT_UP = 4,
    JUMP = 5,
}